//Guardamos el ancho del dispositivo
let ancho = get_browser_width();

//--- Cargar los mapas en los textos útiles.  ---//
//--- Ej: <img class="loadImgFullScreen imgFullScreenFloatRight" src="/assets/img/maps/mapa-ferrari-land.jpg"> ---//
//--- Clases para alterar comportamiento: imgFullScreenCenter, imgFullScreenFloatLeft, imgFullScreenFloatRight ---//

function removeClassDelete(tam = 'lg'){
    if(tam == 'lg'){
        var breakpoint = 992;
    }

    if(window.innerWidth < breakpoint){
        $('.cl-' + tam + '-non-delete').remove();
        $('.cl-' + tam + '-delete').removeClass('d-none');
    }else{
        $('.cl-' + tam + '-delete').remove();
        $('.cl-' + tam + '-non-delete').removeClass('d-none');
    }
}

function loadImgFullScreen(start = true){

    if($(".loadImgFullScreen").length){

        if(start){

            var num = 1;

            $(".loadImgFullScreen").each(function(index){

                $(this).parent('p').css({"margin": 0, "padding": 0});

                var add_class = $(this).attr("class").replace("loadImgFullScreen", "");

                $(this).before("<div class='imgFullScreen_" + num + " imgFullScreen " + add_class + " mb-4 main-carousel'><div class='carousel-cell'></div></div>");
                $(this).clone().appendTo(".imgFullScreen_" + num + " .carousel-cell");
                $(this).remove();

                num++;

            });

            $(".imgFullScreen").flickity({
                prevNextButtons: false,
                pageDots: false,
                adaptiveHeight: false,
                fullscreen: true
            });

        }else{

            $(".imgFullScreen").flickity('resize');

        }

    }

}

function hide_show_gallery(text,id){

    if(ancho >= 992){

        if(text.toLowerCase().indexOf("mapa") > -1 || text.toLowerCase().indexOf("map") > -1 || text.toLowerCase().indexOf("carte") > -1){
            $('.cl-ctn-section-gallery').removeClass('d-lg-block');
            $('.cl-ctn-section-gallery').addClass('d-lg-none');
        }else{
            $('.cl-ctn-section-gallery').removeClass('d-lg-none');
            $('.cl-ctn-section-gallery').addClass('d-lg-block');
        }

    }

}

//--- Botones tabs ---//

function start_btn_tabs(btn, selector){
    $(selector).removeClass('active');
    $(selector).attr("aria-selected","false");
    btn.tab('show');
    $('#tabs-' + btn.data('id')).addClass('active');
}

$('#menu_tabs a').on('click', function (event) {
    event.preventDefault();
    start_btn_tabs($(this), '#menu_tabs a');
    hide_show_gallery($(this).text(),$(this).data('id'));
    loadImgFullScreen(false);
});

// OLD - Mantenido hasta que se compruebe que el nuevo no rompe en ningún caso
// $('.btn_tabs a').on('click', function (event) {
//     event.preventDefault();
//     start_btn_tabs($(this), '.btn_tabs a');
// });

// NEW
$('.btn_tabs').each( function(i) {
    let test = $(this).find('a');
    $(test).on('click', function (event) {
        start_btn_tabs($(this), test);

        let carousel = $(".carousel.flickity-enabled");
        $('.btn_tabs').on('shown.bs.tab', function (e) {
            carousel.flickity('resize');
        });
    })
})

//--- FIN - Botones tabs ---//

//--- Botón leer más en texto útiles ---//

function countLines(num) {

    //Para los textos en otros tabs
    if(num != 1){

        var previousCss  = $('#tabs-'+num).attr("style");

        $('#tabs-'+num).css({
            position:   'absolute',
            visibility: 'hidden',
            display:    'block'
        });

    }

    var el = document.getElementById('ctn-see-more-txt-'+num);
    var divHeight = el.offsetHeight;
    var num_rem = parseFloat(el.style.lineHeight.replace('rem', '')); //line height en rems
    var lineHeight = 16 * num_rem; // Lo pasamos a px
    var lines = divHeight / lineHeight;

    if(num == 999){ //Es el ID usado para el texto intro de la página

        if(ancho < 992){
            var limit_lines = 2;
            var ellipsis_class_name = 'txt-ellipsis-2';
        }else{
            var limit_lines = 4;
            var ellipsis_class_name = 'txt-ellipsis-4';
        }

    }else{

        var limit_lines = 16;
        var ellipsis_class_name = 'txt-ellipsis-16';

    }

    if(Math.floor(lines) > limit_lines){
        $('#ctn-see-more-txt-'+num).addClass(ellipsis_class_name);
        $('.btn-see-more-txt-' + num).show();
    }

    //Para los textos en otros tabs
    if(num != 1){
        $('#tabs-'+num).attr("style", previousCss ? previousCss : "");
    }

}

$('.ctn-see-more-txt').each(function( index ) {

    if($(this).data('id') == 999){
        if(ancho < 992){
            countLines($(this).data('id'));
        }
    }

});

$('.btn-see-more-txt').click(function() {

    if($(this).data('id') == 999){ //Es el ID usado para el texto intro de la página

        if(ancho < 992){
            var ellipsis_class_name = 'txt-ellipsis-2';
        }else{
            var ellipsis_class_name = 'txt-ellipsis-4';
        }

    }else{

        var ellipsis_class_name = 'txt-ellipsis-16';

    }

    if($(this).data('type') == 1){
        $('#ctn-see-more-txt-' + $(this).data('id')).addClass(ellipsis_class_name);
        $('.btn-see-more-txt-' + $(this).data('id')).show();
        $('.btn-see-less-txt-' + $(this).data('id')).hide();
    }else{
        $('#ctn-see-more-txt-' + $(this).data('id')).removeClass(ellipsis_class_name);
        $('.btn-see-more-txt-' + $(this).data('id')).hide();
        $('.btn-see-less-txt-' + $(this).data('id')).show();
    }

});

const collapse_marker_list = () => {

    const x = get_browser_width();
    const y = get_browser_height();
    const components = [...document.querySelectorAll('.js-markers-map')];
    components.forEach(component => {
        const nodes = [...component.querySelectorAll('.cl-markers-map__col')];
        nodes.forEach(node => {
            const collapser = node.querySelector('.cl-markers-map__collapser');
            const btn = [...node.querySelectorAll('.cl-markers-map__collapse-btn')];
            if (x >= 768) {
                collapser.classList.add("show");
            } else {
                collapser.classList.remove("show");
            }
            
        });
    });

}

//--- FIN - Botón leer más en texto útiles ---//

$(document).ready(function() {

    carousel_init(ancho); //Iniciar los carousel
    popovers_init();
    changeImageHeaderSearcher();
    loadImgFullScreen();
    collapse_marker_list();
    removeClassDelete();
    activar_modal_btn_webcams();
    activar_modal_btn_slope_maps();
    
});